import React, { useState, useEffect } from "react";
import cn from "classnames";
import Draggable from "react-draggable";
import Icon from "./Icon";

const BACKDROPS_NUMBER = 9;

const POPUP_WIDTH = 224;
const POPUP_HEIGHT = 320;

const Backdrops = React.memo(({
  mouse,
  visible,
  onClick,
  onHide,
  onMouseEnter,
  onMouseLeave,
  backdrop,
  style,
  onChange
}) => {

  const [x, setX] = useState();
  const [y, setY] = useState();

  useEffect(() => {
    if ((mouse.x + POPUP_WIDTH) > window.innerWidth) {
      setX(window.innerWidth - POPUP_WIDTH);
    } else {
      setX(mouse.x);
    }
    if ((mouse.y + POPUP_HEIGHT) > window.innerHeight) {
      setY(window.innerHeight - POPUP_HEIGHT);
    } else {
      setY(mouse.y);
    }
  }, [mouse]);

  const handleStop = (e, data) => {
    setX(data.lastX);
    setY(data.lastY);
  }

  const nodeRef = React.useRef(null);

  return (
    <Draggable
      position={{ x: x, y: y }}
      onStop={handleStop}
      handle=".popup__head"
      bounds={{
        top: 0,
        left: 0,
        right: window.innerWidth - POPUP_WIDTH,
        bottom: window.innerHeight - POPUP_HEIGHT
      }}
      nodeRef={nodeRef}>
      <div className="popup popup--backdrops"
        onClick={onClick}
        ref={nodeRef}>
        <div className={cn("popup__container", { visible: visible })}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <button className="popup__close" onClick={onHide}>
            <Icon.Close />
          </button>
          <div className="popup__head">Backdrops</div>
          <div className="popup__body">
            <div className="backdrops">
              {new Array(BACKDROPS_NUMBER).fill().map((x, index) =>
                <div className={cn("backdrops__item", { active: +backdrop === index })}
                  onClick={() => onChange(index)}
                  key={index}>
                  <img
                    className="backdrops__pic"
                    src={`/images/backdrops/${style}/previews/${index}.svg`}
                    alt={`Backdrop ${index}`} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Draggable>
  );
});

Backdrops.displayName = 'Backdrops';

export default Backdrops;